<template>
  <div class="footer">
    <span class="text-black">
      <a v-if="this.$store.getters['user/isFilterOn']({id: 'mobaku'})" @click="openNotes" class="break-all">{{$t('tour_about_mobaku')}}</a>
      {{ $t('tour_copyright_first') }} {{ $t('tour_copyright') }} / <a @click="openPolicy">クッキーポリシー</a> / <a @click="openTerms">規約</a>
    </span>
  </div>
</template>

<script>
export default {
  data () {
    return {}
  },
  methods: {
    openNotes: function () {
      this.$store.dispatch('map/setShowDocomoMobaku', true)
    },
    openPolicy: function () {
      //クッキーポリシーを開く
      this.$router.push( {name: 'policy', params: { lang: this.lang } })
    },
    openTerms: function () {
      //規約を開く
      this.$router.push( {name: 'terms', params: { lang: this.lang } })
    },

  }
}
</script>
